import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import { MutationBlobStorageIntegrationUpdateArgs } from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { UPDATE_BLOB_STORAGE_INTEGRATION } from "./gql";

const useBlobStorageIntegrationUpdate = createDefaultMutationHook(UPDATE_BLOB_STORAGE_INTEGRATION);

const useUpdateBlobStorageIntegration = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [blobStorageIntegrationUpdate, { loading }] = useBlobStorageIntegrationUpdate({
    refetchQueries: ["SearchVCSIntegrations"],
  });

  const updateBlobStorageIntegration = useCallback(
    (input: MutationBlobStorageIntegrationUpdateArgs, successCallback?: () => void) => {
      blobStorageIntegrationUpdate(input, (data) => {
        if (data?.blobStorageIntegrationUpdate) {
          reportSuccess({
            message: `Integration ${data.blobStorageIntegrationUpdate.name} was successfully updated`,
          });
          successCallback?.();

          trackSegmentAnalyticsEvent("Integration Edit - Finish", {
            integration: "Blob Storage",
          });
        }
      });
    },
    [blobStorageIntegrationUpdate, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return {
    updateBlobStorageIntegration,
    loading,
  };
};

export default useUpdateBlobStorageIntegration;
